import dayjs from 'dayjs';
import { convertDateToBE } from 'utils/constants/functions';

export interface IGetPurchaseInvoice {
  take?: number;
  skip?: number;
  state?: string; //
  id?: string;
  poId?: string;
  customerId?: string;
  fromDate?: string;
  toDate?: string;
  purchaseType?: string;
  purchaseStatus?: string;
  childPurchaseOrderId?: string;
  plantId?: string;
  teamSalesId?: string;
}

export interface IGetPurchaseInvoiceMaterials {
  pageSize?: number;
  value?: string;
}

export interface IPurchaseInvoiceSeparation {
  id: string;
  amount: number;
}

export interface IUpdatePurchaseOrderForAcountant {
  purchaseOrderId: string;
  purchaseOrderDetailId: string;
  measureWeightThread: number;
  lossWeightThread: number;
  includeWeightThread: number;
  sloc: string;
}

export interface ICalculateItemSeparationPrice {
  purchaseOrderId: string;
  purchaseOrderDetailId: string;
  items: Array<{ weightThread: number }>;
}

export interface ICancelPurchaseInvoiceItemSeparation {
  id: string;
  detailId: string;
}

export interface IMovePurchaseInvoiceItemParams {
  toId: string;
  fromId: string;
  detailId: string;
}

export interface ISapPurchaseOrder {
  tranId: string;
  plant: string;
}

export interface SaveOrderParams {
  customerId: string;
  marketGoldPriceId: string;
  marketPrice: number;
  customerCheckinId: string;
  orderIds?: any[];
}

export interface IUpdateOrderParams {
  customerId: string;
  customerType: string;
  dealPrice: number | null;
  deductType: string;
  docType: string;
  marketGoldPriceId?: string;
  marketPrice?: number;
  note: string | null;
  poId: string | null;
  policyType: string;
  purchaseOrderId: string;
  purchaseOrderDetail: any[];
  purchaseType: string;
  purchType: string;
  orderIds: any[];
  q10Surplus: number;
  usePolicyPrice: boolean;
  customerCheckinId: string;
}

export interface ICreateDealPrice {
  salePrice: number;
  dealPrice: number;
  purchaseId: string;
  usePolicyPrice: boolean;
  note: string;
}

export interface IGetOrederIdCbx {
  plantId?: string;
  createRole?: string;
  customerId: string;
  teamSalesId?: string | undefined;
}

export interface IPrintFile {
  id: string;
  type: 'pdf' | 'excel' | 'print';
}

export const PURCHASE_INVOICE_VARIABLE = {
  getPurchaseInvoice: (params: IGetPurchaseInvoice) => {
    const {
      take,
      skip,
      id,
      childPurchaseOrderId,
      customerId,
      fromDate,
      plantId,
      poId,
      purchaseStatus,
      purchaseType,
      teamSalesId,
      toDate,
    } = params;

    return {
      take: take,
      skip: skip,
      input: {
        ...(id && { purchaseOrderId: id }),
        ...(poId && { poId }),
        ...(plantId && { plantId }),
        ...(customerId && { customerId }),
        ...(purchaseStatus && { purchaseStatus }),
        ...(purchaseType && { purchaseType }),
        ...(teamSalesId && { teamSalesId }),
        ...(childPurchaseOrderId && { childPurchaseOrderId }),
        ...(fromDate && {
          fromDate: convertDateToBE(dayjs(fromDate, 'DD/MM/YYYY')),
        }),
        ...(toDate && {
          toDate: convertDateToBE(dayjs(toDate, 'DD/MM/YYYY')),
        }),
      },
    };
  },
  getPurchaseInvoiceById: (params: IGetPurchaseInvoice) => {
    const { id } = params;

    return {
      id,
    };
  },
  getPurchaseInvoiceDealPrice: (id: string) => {
    return { input: { id } };
  },
  getPurchaseOrderSeparation: (id: string) => {
    return { id };
  },
  updatePurchaseOrderWeightForAccountant: (
    params: IUpdatePurchaseOrderForAcountant,
  ) => {
    // const {
    //   purchaseOrderId,
    //   purchaseOrderDetailId,
    //   measureWeightThread,
    //   lossWeightThread,
    //   includeWeightThread,
    // } = params;

    return {
      // data: {
      //   ...(purchaseOrderId && { purchaseOrderId }),
      //   ...(purchaseOrderDetailId && { purchaseOrderDetailId }),
      //   ...(measureWeightThread && { measureWeightThread }),
      //   ...(lossWeightThread && { lossWeightThread }),
      //   ...(includeWeightThread && { includeWeightThread }),
      // },
      data: params,
    };
  },
  purchaseInvoiceSeparation: (params: IPurchaseInvoiceSeparation) => {
    return params;
  },
  purchaseInvoiceItemSeparation: (params: ICalculateItemSeparationPrice) => {
    return { input: { ...params } };
  },
  cancelPurchaseInvoiceItemSeparation: (
    params: ICancelPurchaseInvoiceItemSeparation,
  ) => {
    return params;
  },
  calculateItemSeparationPrice: (params: ICalculateItemSeparationPrice) => {
    return { input: { ...params } };
  },
  cancelPurchaseInvoiceSeparation: (id: string) => {
    return { id };
  },
  movePurchaseInvoiceItem: (params: IMovePurchaseInvoiceItemParams) => {
    return params;
  },
  savePurchaseOrderSeparation: (id: string) => {
    return { id };
  },
  getPurchaseInvoiceMaterials: (params: IGetPurchaseInvoiceMaterials) => {
    const { pageSize, value } = params;

    return {
      skip: 0,
      take: pageSize || 10,
      input: {
        ...(value && {
          OR: [
            {
              id: {
                contains: value,
              },
            },
            {
              name: {
                contains: value,
              },
            },
          ],
        }),
        category: {
          equals: 'R',
        },
      },
    };
  },
  getTypePurchase: () => {
    return {
      input: {
        groupId: {
          equals: '800',
        },
      },
    };
  },
  getPurchaseStatusCbx: () => {
    return {
      input: {
        groupId: {
          equals: 'PUR00',
        },
      },
    };
  },
  getUnitPurchase: () => {
    return {
      input: {
        groupId: {
          equals: 'PY101',
        },
      },
    };
  },
  getTypePolicyPurchase: () => {
    return {
      input: {
        groupId: {
          equals: 'PY100',
        },
      },
    };
  },
  getTypeOfDocPurchase: () => {
    return {
      input: {
        groupId: {
          equals: 'Z100',
        },
      },
    };
  },
  getTypeCustomer: () => {
    return {
      input: {
        groupId: {
          equals: 'CT100',
        },
      },
    };
  },
  getMarketGoldPrice: (date: string) => {
    return {
      skip: 0,
      take: 25,
      input: {
        validFromDate: date,
      },
    };
  },
  getMarketGoldPriceApproval: (id: string) => {
    return {
      input: { id },
    };
  },
  postPurchaseOrder: (params: SaveOrderParams) => {
    const {
      customerCheckinId,
      customerId,
      marketGoldPriceId,
      marketPrice,
      orderIds,
    } = params;

    return {
      input: {
        customerId: customerId,
        customerType: null,
        dealPrice: null,
        deductType: null,
        docType: null,
        marketGoldPriceId: marketGoldPriceId,
        marketPrice: marketPrice,
        note: null,
        poId: null,
        policyType: null,
        purchaseOrderId: null,
        purchaseOrderDetail: [],
        purchaseType: '',
        purchType: null,
        ...(orderIds && { orderIds }),
        q10Surplus: null,
        usePolicyPrice: false,
        customerCheckinId: customerCheckinId,
      },
    };
  },
  updatePurchaseOrder: (params: IUpdateOrderParams) => {
    const { marketGoldPriceId, marketPrice, orderIds, ...others } = params;

    return {
      input: {
        ...others,
        ...(marketGoldPriceId && { marketGoldPriceId }),
        ...(marketPrice && { marketPrice }),
        ...(orderIds && { orderIds }),
      },
    };
  },
  completePurchaseOrder: (id: string) => {
    return { id };
  },
  createDealPrice: (params: ICreateDealPrice) => {
    return {
      input: params,
    };
  },
  getOrderTempIdCbx: (params: IGetOrederIdCbx) => {
    const { customerId, teamSalesId, plantId, createRole } = params;

    return {
      input: {
        ...(customerId && {
          customerId: {
            equals: customerId,
          },
        }),
        ...(teamSalesId && {
          teamSalesId: {
            equals: teamSalesId,
          },
        }),
        ...(createRole && {
          createRole: {
            equals: createRole,
          },
        }),
        ...(plantId && {
          plantId: {
            equals: plantId,
          },
        }),
      },
    };
  },
};
